import styled from "styled-components";

import { theme } from "../../styles/theme";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  font-family: ${theme.font.poppins};
`;

export const Button = styled.button`
  background-color: ${theme.colors.darkBlue};
  margin: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;

  path {
    fill: ${theme.colors.white};
  }

  @media screen and (max-width: 479px) {
    width: 40px;
    height: 40px;
    padding: 10px;
  }
`;

export const Text = styled.span`
  color: ${theme.colors.white};
  font-weight: ${theme.font.bold};
  font-size: ${theme.font.sizes.xsmall};

  @media screen and (max-width: 479px) {
    font-size: ${theme.font.sizes.normal};
  }
`;
